var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrlShortener(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.83333,
    stroke: "#E0529C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912:2195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6901 16.7588L27.6901 15.2402C27.6899 15.1899 27.6698 15.1416 27.6341 15.106C27.5985 15.0704 27.5503 15.0502 27.4999 15.05L22.1949 15.0517L22.1949 13.2098C22.1949 13.1743 22.1849 13.1395 22.166 13.1094C22.1471 13.0793 22.1201 13.0552 22.0881 13.0397C22.0562 13.0242 22.0205 13.0181 21.9851 13.022C21.9498 13.0259 21.9163 13.0396 21.8885 13.0617L18.3092 15.8497C18.2115 15.9271 18.2115 16.0719 18.3092 16.1494L21.8902 18.9391C22.0147 19.0367 22.1949 18.9475 22.1966 18.7909V16.9491L27.5032 16.9491C27.6043 16.9491 27.6901 16.8632 27.6901 16.7588ZM13.6928 15.8497L10.1118 13.06C9.9872 12.9623 9.80537 13.0533 9.80537 13.2082L9.80537 15.05L4.50207 15.05C4.45169 15.0502 4.40345 15.0704 4.36782 15.106C4.3322 15.1416 4.31208 15.1899 4.31183 15.2402L4.31183 16.7588C4.31183 16.8632 4.39769 16.9491 4.50207 16.9491L9.80874 16.9491L9.80874 18.7909C9.80875 18.8265 9.81877 18.8613 9.83765 18.8914C9.85653 18.9214 9.88351 18.9456 9.9155 18.9611C9.94748 18.9765 9.98317 18.9827 10.0185 18.9788C10.0538 18.9749 10.0873 18.9611 10.1152 18.9391L13.6928 16.1494C13.7159 16.1318 13.7346 16.1092 13.7475 16.0832C13.7605 16.0572 13.7672 16.0286 13.7672 15.9995C13.7672 15.9705 13.7605 15.9419 13.7475 15.9159C13.7346 15.8899 13.7159 15.8672 13.6928 15.8497Z",
    fill: "#E0529C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912:2195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "none",
    transform: "translate(5.33301 5.33333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlShortener);
export default __webpack_public_path__ + "static/media/url_shortener.b949caaeb14cd775fbc8f65aff4e666e.svg";
export { ForwardRef as ReactComponent };